import { render, staticRenderFns } from "./ggList.vue?vue&type=template&id=887bd106&scoped=true"
import script from "./ggList.vue?vue&type=script&lang=js"
export * from "./ggList.vue?vue&type=script&lang=js"
import style0 from "./ggList.vue?vue&type=style&index=0&id=887bd106&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887bd106",
  null
  
)

export default component.exports